export default __webpack_public_path__ + "static/media/LeftFog.f2d36aaa.png";